import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'

export default {
  state: {
    info: {
      domain: '',
      appId: '',
      channelId: '',
      channelName: '',
      email: '',
      package: '',
      customToken: '',
      lang: '',
      colorMain: '',
      colorSub: ''
    }
  },
  mutations,
  actions,
  getters
}
